import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=75c0c10d&scoped=true&"
import script from "./sign.vue?vue&type=script&lang=js&"
export * from "./sign.vue?vue&type=script&lang=js&"
import style0 from "./sign.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sign.vue?vue&type=style&index=1&id=75c0c10d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0c10d",
  null
  
)

export default component.exports